import React from 'react'
import Fragment from '../common/fragment'


function FragmentAX(props) {
  return (
    <Fragment pos="x" {...props}>
      <p>
Desde la azotea del Convento, se ven las chimeneas de la Refinería. Como un
bosque de metales preciosos y humos que se elevan. Cualquier mirada es indiferente
“Sólo si conociéramos podríamos entender” (Brecht). Vemos a lo lejos, como si
entre las neblinas químicas y las torres metálicas empezara la inquietud. Las puertas
del valle.
      </p>
    </Fragment>
  )
}


export default FragmentAX
